import HeaderPortal from 'containers/DriverPortalPage/components/HeaderPortal';
import { FormikProps, FormikValues } from 'formik';
import { useIsWebView } from 'hooks/useIsWebView';
import React from 'react';
import DocumentsReviewStatus from './DocumentsReviewStatus';
import Logout from './Logout';

export interface IHeaderPortal {
  documentsReviewStatusName?: string;
  disabledDivider?: boolean;
  formik?: FormikProps<FormikValues>;
  onShowReturnModal?: Function;
}

const MainHeaderPortal: React.FC<IHeaderPortal> = props => {
  const isWebView = useIsWebView();
  const { documentsReviewStatusName, disabledDivider, formik } = props;
  return (
    <>
      {!isWebView && (
        <HeaderPortal>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DocumentsReviewStatus statusName={documentsReviewStatusName} />
            <Logout disabledDivider={disabledDivider} formik={formik} />
          </div>
        </HeaderPortal>
      )}
    </>
  );
};

MainHeaderPortal.defaultProps = {
  documentsReviewStatusName: '',
};

export default MainHeaderPortal;
